module.exports = __webpack_public_path__ + "static/media/Icono usuarios.0801abed.svg";